import uniqBy from 'lodash/uniqBy';
import { getSelectedOptionsRange, isSelectedOrDisabledItem } from './utils';

export const defaultReducerState = {
  selectedOptions: [],
  inputValue: '',
  startOfSelectionRange: { isInValuesList: false, index: -1 }
};

export function reducer(state, action) {
  switch (action.type) {
    case 'onCreateNewOption': {
      const { newOption } = action.payload;
      const { selectedOptions } = state;
      const nextSelectedOptions = [...selectedOptions, newOption];
      return {
        ...state,
        selectedOptions: nextSelectedOptions
      };
    }
    case 'setSelectedOptions': {
      const { selectedOptions } = action.payload;
      return {
        ...state,
        selectedOptions
      };
    }
    case 'setInputValue': {
      const { inputValue } = action.payload;
      return { ...state, inputValue };
    }
    case 'resetStartOfSelectionRange': {
      return {
        ...state,
        startOfSelectionRange: defaultReducerState.startOfSelectionRange
      };
    }
    case 'onSelect': {
      const {
        values,
        maxValues,
        filteredOptions,
        currentClickedOption,
        isOptionDisabled,
        isShift
      } = action.payload;

      const { selectedOptions, startOfSelectionRange } = state;

      let newValues;
      const isOptionIncludes = selectedOptions.some(
        option => option.value === currentClickedOption.value
      );
      if (isOptionIncludes) {
        newValues = selectedOptions.filter(
          option => option.value !== currentClickedOption.value
        );
      } else {
        newValues = [...selectedOptions, currentClickedOption];
      }

      // default case, no range selection
      let nextSelectedOptions = newValues;

      const isSelectAction = !isOptionIncludes;
      const isDeselectAction = isOptionIncludes;

      const hasStartOfSelectionRange = startOfSelectionRange.index !== -1;

      const isInValuesList = values.some(
        option => option.value === currentClickedOption.value
      );
      const collection = isInValuesList ? values : filteredOptions;
      const currentOptionIndex = collection.findIndex(
        option => option.value === currentClickedOption.value
      );

      const nextStartOfSelectionRange = {
        index: currentOptionIndex,
        isInValuesList
      };

      const isMixedLists =
        isInValuesList !== startOfSelectionRange.isInValuesList;

      if (hasStartOfSelectionRange && !isMixedLists) {
        // range selection case
        nextSelectedOptions = getSelectedOptionsRange({
          collection,
          selectedOptions,
          newValues,
          maxValues,
          isDeselectAction,
          isSelectAction,
          isShiftKeyPressed: isShift,
          currentOptionIndex,
          isOptionDisabled,
          startOfSelectionRange: startOfSelectionRange
        });
      }
      nextSelectedOptions = nextSelectedOptions.filter(
        option => !option.isGroup
      );
      return {
        ...state,
        selectedOptions: nextSelectedOptions,
        startOfSelectionRange: nextStartOfSelectionRange
      };
    }

    case 'selectAll': {
      const { options } = action.payload;
      const { selectedOptions } = state;

      const isAllCheckedOrDisabled = options.every(item =>
        isSelectedOrDisabledItem(item, selectedOptions)
      );

      let nextOptions;
      if (!isAllCheckedOrDisabled) {
        nextOptions = uniqBy([...selectedOptions, ...options], 'value');
        nextOptions = nextOptions.filter(item => !item.isDisabled);
      } else {
        nextOptions = defaultReducerState.selectedOptions;
      }

      return {
        ...state,
        selectedOptions: nextOptions
      };
    }
    case 'selectGroup': {
      const { clickedGroupItem } = action.payload;
      const { selectedOptions } = state;

      const isAllCheckedOrDisabled = clickedGroupItem.items.every(item =>
        isSelectedOrDisabledItem(item, selectedOptions)
      );

      let nextOptions;
      if (!isAllCheckedOrDisabled) {
        const isUnselectedItem = item => {
          return selectedOptions.every(option => option.value !== item.value);
        };
        const groupUnselectedItems = clickedGroupItem.items.filter(
          isUnselectedItem
        );

        nextOptions = uniqBy(
          [...selectedOptions, ...groupUnselectedItems],
          'value'
        );
        nextOptions = nextOptions.filter(item => !item.isDisabled);
      } else {
        const isInClickedGroupItems = option =>
          clickedGroupItem.items.some(item => item.value === option.value);

        nextOptions = selectedOptions.filter(
          item => !isInClickedGroupItems(item)
        );
      }

      return {
        ...state,
        selectedOptions: nextOptions
      };
    }
    default: {
      throw new Error(
        `An action with the type of "${action.type}" was dispatch, but its not supported.`
      );
    }
  }
}

export function initReducer(initialState, props) {
  const { values } = props;
  return {
    ...initialState,
    selectedOptions: values
  };
}
